import React from 'react';

import { Box, Image, Text, Tooltip } from '@mantine/core';
import { FloatingPosition } from '@mantine/core/lib/Floating';
import { IconInfoCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface InfoComponentProps {
  contentTranslationKey: string;
  position?: FloatingPosition;
  width?: number;
  iconSize?: number;
  mutliline?: boolean;
  withinPortal?: boolean;
  disabled?: boolean;
  image?: string;
}

export function InfoComponent({
  contentTranslationKey,
  width = 200,
  position = 'right',
  iconSize = 15,
  mutliline = true,
  withinPortal = false,
  disabled = false,
  image
}: InfoComponentProps) {
  const { t } = useTranslation();

  return (
    <Tooltip
      disabled={disabled}
      position={position}
      multiline={mutliline}
      width={width}
      withArrow
      offset={10}
      withinPortal={withinPortal}
      label={
        <Box>
          <Text weight={400} fz="0.8rem">
            {t(contentTranslationKey)}
          </Text>
          {image && <Image radius={10} mt={10} src={image} />}
        </Box>
      }>
      <IconInfoCircle style={{ width: iconSize, height: iconSize }} />
    </Tooltip>
  );
}
